var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H21.3481C26.8709 0 31.3481 4.47715 31.3481 10V21.9844C31.3481 27.5073 26.8709 31.9844 21.3481 31.9844H10C4.47715 31.9844 0 27.5073 0 21.9844V10Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8018_4474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3728 22.5664V21.1068C20.3728 20.3326 20.0621 19.5901 19.5089 19.0427C18.9558 18.4952 18.2056 18.1877 17.4234 18.1877H12.9992C12.2169 18.1877 11.4667 18.4952 10.9136 19.0427C10.3605 19.5901 10.0497 20.3326 10.0497 21.1068V22.5664",
    stroke: "#155DFC",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2117 15.2686C16.8406 15.2686 18.1611 13.9616 18.1611 12.3494C18.1611 10.7372 16.8406 9.4303 15.2117 9.4303C13.5827 9.4303 12.2622 10.7372 12.2622 12.3494C12.2622 13.9616 13.5827 15.2686 15.2117 15.2686Z",
    stroke: "#155DFC",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8018_4474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(8.16547 8.49219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.43fffd97e3c5a0a7fc531fcb9a1a70c3.svg";
export { ForwardRef as ReactComponent };